// Staff chat inbox — message any clinic or teammate. Realtime via the chat.* SSE events.
// Patient accounts get a single conversation with their own clinic instead (no clinic picker).
import { ROLE_AUDIENCE } from '@alignova/shared';
import { PageHeader } from '../../ui/primitives.tsx';
import { ChatPanel, PatientChat } from '../../ui/ChatPanel.tsx';
import { useAuth } from '../../auth/AuthContext.tsx';

export function ChatPage() {
  const { user } = useAuth();
  if (user && ROLE_AUDIENCE[user.role] === 'patient') {
    return (
      <div className="mx-auto max-w-xl p-2">
        <PageHeader title="Chat" subtitle="Message your clinic." />
        <PatientChat patientName={user.displayName} />
      </div>
    );
  }
  return (
    <div>
      <PageHeader title="Chat" subtitle="Message clinics and coordinate with your team." />
      <ChatPanel mode="staff" />
    </div>
  );
}
